import React from "react";
function MaterialMenu({
  options,
  selectedValues,
  onToggle
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "ff-filter__menu-inner"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ff-filter__grid ff-filter__grid--one"
  }, options.map(opt => {
    const selected = selectedValues.indexOf(opt.value) !== -1;
    return /*#__PURE__*/React.createElement("button", {
      key: opt.value,
      type: "button",
      className: "ff-filter__option",
      onClick: () => onToggle(opt.value)
    }, /*#__PURE__*/React.createElement("div", {
      className: "ff-material-option"
    }, /*#__PURE__*/React.createElement("span", {
      className: "ff-material-option__box" + (selected ? " ff-material-option__box--selected" : "")
    }), /*#__PURE__*/React.createElement("span", {
      className: "ff-material-option__label"
    }, opt.label), opt.count != null && /*#__PURE__*/React.createElement("span", {
      className: "ff-material-option__count"
    }, opt.count)));
  })));
}
export { MaterialMenu };
function ColorMenu({
  options,
  selectedValues,
  onToggle
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "ff-filter__menu-inner"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ff-filter__grid ff-filter__grid--two"
  }, options.map(opt => {
    const selected = selectedValues.indexOf(opt.value) !== -1;
    return /*#__PURE__*/React.createElement("button", {
      key: opt.value,
      type: "button",
      className: "ff-filter__option",
      onClick: () => onToggle(opt.value)
    }, /*#__PURE__*/React.createElement("div", {
      className: "ff-color-option"
    }, /*#__PURE__*/React.createElement("span", {
      className: "ff-color-option__swatch",
      style: {
        backgroundColor: opt.swatch
      }
    }), /*#__PURE__*/React.createElement("span", {
      className: "ff-color-option__label"
    }, opt.label), opt.count != null && /*#__PURE__*/React.createElement("span", {
      className: "ff-color-option__count"
    }, opt.count), selected && /*#__PURE__*/React.createElement("span", {
      className: "ff-color-option__check"
    }, "\u2713")));
  })));
}
export { ColorMenu };
function MaterialMenuTwo({
  options,
  selectedValues,
  onToggle
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "ff-filter__menu-inner"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ff-filter__grid ff-filter__grid--two"
  }, options.map(opt => {
    const selected = selectedValues.indexOf(opt.value) !== -1;
    return /*#__PURE__*/React.createElement("button", {
      key: opt.value,
      type: "button",
      className: "ff-filter__option",
      onClick: () => onToggle(opt.value)
    }, /*#__PURE__*/React.createElement("div", {
      className: "ff-material-option"
    }, /*#__PURE__*/React.createElement("span", {
      className: "ff-material-option__box" + (selected ? " ff-material-option__box--selected" : "")
    }), /*#__PURE__*/React.createElement("span", {
      className: "ff-material-option__label"
    }, opt.label), opt.count != null && /*#__PURE__*/React.createElement("span", {
      className: "ff-material-option__count"
    }, opt.count)));
  })));
}
export { MaterialMenuTwo };
function SortMenu({
  options,
  selectedValues,
  onToggle
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "ff-filter__menu-inner"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ff-filter__grid ff-filter__grid--one"
  }, options.map(opt => {
    const selected = selectedValues.indexOf(opt.value) !== -1;
    return /*#__PURE__*/React.createElement("button", {
      key: opt.value,
      type: "button",
      className: "ff-filter__option",
      onClick: () => onToggle(opt.value)
    }, /*#__PURE__*/React.createElement("div", {
      className: "ff-material-option"
    }, /*#__PURE__*/React.createElement("span", {
      className: "ff-material-option__box" + (selected ? " ff-material-option__box--selected" : "")
    }), /*#__PURE__*/React.createElement("span", {
      className: "ff-material-option__label"
    }, opt.label), opt.count != null && /*#__PURE__*/React.createElement("span", {
      className: "ff-material-option__count"
    }, opt.count)));
  })));
}
export { SortMenu };